'use strict';

angular.module('app')
  .service('affiliatesService', function(Request, GTM, $rootScope, info) {
    return {
        createNew: function (data) {
            if (data && data.country === 'global') {
                data.country = null;
            }
            return Request.post('account/affiliate/new/', data).then(function (res) {
                GTM.event('affiliate_registration_complete');

                var programm = null,
                    index = _.findIndex(info.account.AFFILITATE_KIND, function(val) {
                        return val[0] == res.data.kind;
                    });
    
                    if (index !== -1) {
                        programm = info.account.AFFILITATE_KIND[index][1];
                    }

                GTM.variables({
                    affiliate_id: res.data.id,
                    affiliate_program: programm
                });

                return res.data;
            }).catch(function(error) {
                if (error.data.nonFieldErrors) {
                    $rootScope.showNotify(error.data.nonFieldErrors[0])
                }
                return error;
            })
        }
    }
});